import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { zodResolver } from "@hookform/resolvers/zod";

import { addCommunitySchema } from "../../schemas";
import { closeModal } from "../../features/modalSLice";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import AddResource from "../../components/header/AddResource";
import { addCommunity, editCommunity } from "../../features/communitiesSlice";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import Loading from "../../components/loading/Loading";
import { getOrganizations } from "../../features/organizationsSlice";
import { useNotification } from "../../components/notification/NotificationContainer";
import loadStatus from "../../util/loadStatus";

const AddCommunity = ({ edit, id }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const organizations = useSelector((state) => state.organizations.data);
  const community = useSelector((state) => state.communities.selected);
  const communityLoad = useSelector(
    (state) => state.communities.load.getCommunity
  );
  const addCommunityLoad = useSelector(
    (state) => state.communities.load.addCommunity
  );
  const editCommunityLoad = useSelector(
    (state) => state.communities.load.editCommunity
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(addCommunitySchema),
    defaultValues: { name: "" },
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      if (edit) {
        const res = await dispatch(editCommunity({ id, reqData: data }));
        if (editCommunity.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Community Updated Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        const res = await dispatch(addCommunity(data));
        if (addCommunity.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Community Added Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getOrganizations());
  }, []);

  useEffect(() => {
    if (community.id) {
      reset({
        organization_id: community.organization_id,
        name: community.name,
        email: community.email,
        address1: community.address1,
        address2: community.address2,
        city: community.city,
      });
    }
  }, [community, organizations]);

  if (communityLoad === loadStatus.loading && edit) {
    return (
      <div className="min-w-72 sm:min-w-96 lg:min-w-96 w-full h-96">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-w-72 sm:min-w-[26rem] lg:min-w-96">
      <AddResource title={edit ? "Edit Community" : "Add Community"} />
      <form
        autoCorrect="off"
        autoComplete="off"
        aut
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col justify-center items-center gap-2 w-full">
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Name"
            name="name"
            errors={errors.name}
          />
          <InputField
            register={register}
            type="email"
            autoComplete="off"
            label="Email"
            name="email"
            errors={errors.email}
          />
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Address 1"
            name="address1"
            errors={errors.address1}
          />

          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Address 2"
            name="address2"
            errors={errors.address2}
          />
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="City"
            name="city"
            errors={errors.city}
          />
          <SelectField
            data={[{ id: "", name: "-- Select Antenna" }, ...organizations]}
            register={register}
            label="Organization"
            name="organization_id"
            errors={errors.organization_id}
          />
        </div>
        {/* <div className="flex items-center justify-end py-6">
          <button className="add-rss-btn" type="submit">
            Submit
          </button>
        </div> */}
        <ResourseButtons loading={addCommunityLoad || editCommunityLoad} />
      </form>
    </div>
  );
};

export default AddCommunity;
